import { apiRequest } from "@/api/client";
import { TTL_6_HOURS, cacheKey, cachedFetch } from "@/lib/api-cache";
import { onlyDigits } from "@/lib/format";
import type { CnpjDetail } from "@/types/api";

/** Ficha completa de um CNPJ (14 dígitos). Cacheada em memória por 6h. */
export function fetchCnpjDetail(cnpj: string, _signal?: AbortSignal): Promise<CnpjDetail> {
  const digits = onlyDigits(cnpj);
  return cachedFetch(cacheKey("GET /cnpj", digits), TTL_6_HOURS, () =>
    apiRequest<CnpjDetail>(`/cnpj/${digits}`),
  );
}
